<template>
  <v-menu bottom left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list>
      <cancelar-solic-atualiz-cad :solic="solic" v-if="solic.status < 3" />
      <movimentacao-atestado :movimentacao="solic.movimentacao" />
    </v-list>
  </v-menu>
</template>

<script>
import MovimentacaoAtestado from "../../atestados/listar-atestados/components/MovimentacaoAtestado.vue";
import CancelarSolicAtualizCad from "../components/CancelarSolicAtualizCad.vue";
export default {
  props: {
    solic: Object,
  },
  components: {
    CancelarSolicAtualizCad,
    MovimentacaoAtestado,
  },
};
</script>

<style>
</style>